<template>
	<div class="info-list">
		<div
			class="info-list-title"
			v-if="title"
			v-text="localize ? $t(title) : title"
		/>
		<div
			class="info-list-item"
			v-for="item in items"
			:key="item.id || item.label"
		>
			<div class="info-list-label">
				<slot name="label" :item="item">
					{{ localize ? $t(item.label) : item.label }}
				</slot>
			</div>
			<div class="info-list-value">
				<slot name="value" :item="item">
					{{ getValue(item) }}
				</slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'InfoList',
	props: {
		title: String,
		items: Array,
		localize: { type: Boolean, default: null },
	},
	methods: {
		getValue(item) {
			return item?.value ?? '-'
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.info-list {
	color: var(--neutral-600);
	font-size: 14px;
	font-family: Avenir-Heavy;
	.info-list-title {
		font-size: 12px;
		margin-bottom: 16px;
		color: var(--neutral-800);
		font-family: Avenir-Roman;
	}
	.info-list-item {
		@include flex-spread;
		margin-bottom: 12px;
		.info-list-label {
			color: var(--neutral-400);
			font-family: Avenir-Roman;
		}
	}
}
</style>
